import { downloadCsvRows } from '../../../helpers/downloadCsvRows'
import { STATUS_LABELS } from '../constants/dailySettlementControlConstants'

export const exportDailySettlementControlCsv = (rows, date) => {
  downloadCsvRows(
    [
      [
        'Usuario',
        'Código',
        'Cobros',
        'Monto cobrado',
        'Cobros sin liquidar',
        'Monto pendiente',
        'Liquidación'
      ],
      ...rows.map((row) => [
        row.user_full_name,
        row.user_uid,
        row.charges_count,
        row.collected_amount,
        row.pending_charges_count,
        row.pending_amount,
        STATUS_LABELS[row.status]
      ])
    ],
    `control-diario-${date}.csv`
  )
}
